import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'

function LoyaltyCreditCardEmployeeEmailModal() {
  const intl = useIntl()

  return <Modal
    title={intl.formatMessage({
      id: 'MdA3bj1EleVQOzR1ATVi',
      defaultMessage: 'Use your work email to apply',
      description: 'Title of the credit card modal shown to employees using an aliased email address',
    })}
    primaryActionText={intl.formatMessage({
      id: 'xDlVz5Bg7pKNcR8bUZcG',
      defaultMessage: 'Got it',
      description: 'Button dismissing the credit card employee email alias warning modal',
    })}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: '2jtng25PGZXq6D6BW5CM',
        defaultMessage: 'To access the staff discount, switch accounts to your employee email address, e.g. john.smith@luxuryescapes.com, without a ‘+’ alias.',
        description: 'Instructions for employees to use their official non-aliased LE account before applying for the credit card staff discount',
      })}
    </BodyText>
  </Modal>
}

export default LoyaltyCreditCardEmployeeEmailModal
